import React from "react";
import * as yup from "yup";
import Form from "@Components/Form";
import { URLS, SOURCE_URL } from "configs/constants";

const initialValues = {
  name: "",
  active: true,
};
const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Name is required") 
    .matches(/^[a-zA-Z0-9.()/\- ]+$/, "Special characters are not allowed")
    .max(6, "Ensure this field has no more than 6 characters."), 

  active: yup.boolean(),
});

const SourceForm = () => {
    let formFields = [
      {
        type: "input",
        name: "name",
        label: "Name",
        required: true,
        gridSize: { xs: 12, sm: 8, md: 9, lg: 6 },

      },
      
      {
        name: "active",
        type: "switch",
        label: "Status",
        color: "primary",
        gridSize: { xs: 12, sm: 8, md: 9, lg: 6 },


      },
    ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];



  return (
    <Form
      initialValues={initialValues}
      submitUrl={SOURCE_URL}
      validationSchema={validationSchema}

      listRoute={URLS.SOURCE_CUSTOM_FIELDS}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Source"
    />
  );
};

export default SourceForm;
